module.exports = __webpack_public_path__ + "static/media/no-invite-manager.bd2d85af.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroom/no-invite-manager.png
// module id = 1959
// module chunks = 6